import { LoadingButton } from '@mui/lab';
import { Alert, Button, Stack, Typography } from '@mui/material';
import {
  useResetPasswordSubmitMutation,
  useVerifyPwResetRequestQuery,
} from 'api/client-domain/client-domain';
import IncForm from 'components/forms/inc-form/inc-form.component';
import { useResetPasswordSubmitForm } from 'components/forms/reset-password-submit-form/reset-password-form.hooks';
import ResetPasswordSubmitForm from 'components/forms/reset-password-submit-form/reset-password-submit-form.component';
import LoginLayout from 'components/layouts/login-layout/login-layout.component';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ResetPasswordSubmit = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const formMethods = useResetPasswordSubmitForm();
  const [searchParams] = useSearchParams();

  const token = searchParams.get('id');

  const { isLoading: isVerifying, isError: isVerifyError } =
    useVerifyPwResetRequestQuery(token);

  const [resetPasswordSubmit, { isLoading, isSuccess }] =
    useResetPasswordSubmitMutation();

  const onLoginClick = () => {
    navigate('/login');
  };

  const onSubmit = async formData => {
    await resetPasswordSubmit({ ...formData, token });
  };

  return (
    <LoginLayout>
      {isSuccess ? (
        <Stack spacing={2}>
          <Alert severity="success">
            <Stack spacing={1}>
              <Typography>
                {t('page.resetPasswordSubmit.passwordResetSuccess.message')}
              </Typography>
            </Stack>
          </Alert>
          <Button onClick={onLoginClick}>
            {t(
              'page.resetPasswordSubmit.passwordResetSuccess.loginButton.label',
            )}
          </Button>
        </Stack>
      ) : (
        <IncForm
          formMethods={formMethods}
          onSubmit={formMethods.handleSubmit(onSubmit)}
        >
          <ResetPasswordSubmitForm />
          <LoadingButton
            loading={isLoading || isVerifying}
            disabled={isVerifyError}
            type="submit"
            fullWidth
            sx={{ mt: 2 }}
          >
            {t('page.resetPasswordSubmit.passwordResetForm.submitButton.label')}
          </LoadingButton>
        </IncForm>
      )}
    </LoginLayout>
  );
};

export default ResetPasswordSubmit;
